import { render, staticRenderFns } from "./onebox-inboxsourcesystem.vue?vue&type=template&id=4ff1d21e&"
import script from "./onebox-inboxsourcesystem.vue?vue&type=script&lang=js&"
export * from "./onebox-inboxsourcesystem.vue?vue&type=script&lang=js&"
import style0 from "./onebox-inboxsourcesystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports